// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JVR9","title":"styles_title__MXaH6"};